import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Select,
  FormErrorMessage,
  useDisclosure,
  Box,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { onUpdateOrderStatus, getStatus, getSubStatus, getRejectedReasons } from "../../../api/orders";

export function UpdateStatus({ row, setOpenLoader, fetchData, filterQuery }) {
  const finalRef = React.useRef(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const [statuses, setStatuses] = React.useState([]);
  const [subStatuses, setSubStatuses] = React.useState([]);
  const [rejectionReasons, setRejectionReasons] = React.useState([]);

  const {
    register,
    handleSubmit,
    formState,
    setValue,
    watch,
    reset,
    unregister,
  } = useForm({
    defaultValues: {
      status: "",
      subStatus: "",
      rejectionReason: "",
    },
  });

  const { errors, isDirty } = formState;
  const form = watch();

  const handelSubmit = async (data) => {
    setOpenLoader(true);
    const body = {
      sub_status: data.subStatus,
      status: data.status,
      rejection_reason: data.rejectionReason,
      order_id: row.orderId,
    };
    const res = await onUpdateOrderStatus(body, toast);
    if (res) {
      onCloseUpdateStatus();
      toast({
        status: "success",
        title: "",
        description: "Updated successfully",
      });
    }
    setOpenLoader(false);
  };

  const onError = (errors) => console.log(errors);

  const onCloseUpdateStatus = () => {
    reset();
    onClose();
    fetchData(filterQuery);
  };

  useEffect(() => {
    register("status", { required: "status is required" });
    register("subStatus", { required: "sub status is required" });
    register("rejectionReason");
    if (row) {
      setValue("status", row.status);
      setValue("subStatus", row.sub_status);
      setValue("rejectionReason", row.rejection_reason);
    }
    if (row && isOpen) {
      getStatus(toast).then(res => setStatuses(res.statuses));
      if (form["status"]) {
        getSubStatus(toast, form["status"], row.type).then(res => setSubStatuses(res.subStatuses));
      }
      if (form["subStatus"]) {
        getRejectedReasons(toast, form["subStatus"], row.type).then(res => setRejectionReasons(res.rejectionReasons));
      }
    }
  }, [isOpen]);

  return (
    <>
      <Box
        display={"flex"}
        alignItems={"center"}
        width={"100%"}
        cursor={"pointer"}
        onClick={onOpen}
      >
        <Text onClick={onOpen}>Update Status</Text>
      </Box>
      <Modal
        isCentered
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onCloseUpdateStatus}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Update Status</ModalHeader>
          <ModalCloseButton />
          <ModalBody display={"flex"} flexDir={"column"} gap={8}>
            <FormControl
              isInvalid={!!errors.status}
              isRequired
              onChange={(e) => {
                setValue("status", e.target.value);
                setValue("subStatus", "");
                setValue("rejectionReason", "");
              }}
            >
              <FormLabel fontSize={12} fontWeight={"semibold"}>
                Status
              </FormLabel>
                <Select
                  onChange={async (e) => {
                    setValue("status", e.target.value);
                    if (e.target.value) {
                      const { subStatuses: subStatusesList } = await getSubStatus(toast, e.target.value, row.type);
                      setSubStatuses(subStatusesList);
                    }
                  }}
                  value={form["status"]}
                  placeholder="Select option">
                  {statuses?.length && (statuses.map((status, i) => (
                    <option key={i} value={status.value}>
                      {status.label}
                    </option>
                  )))}
                </Select>
              <FormErrorMessage>{errors.status?.message}</FormErrorMessage>
            </FormControl>

            <FormControl
              isInvalid={!!errors.subStatus}
              isRequired
              onChange={async (e) => {
                if (e.target.value === "failed attempt")
                  register("rejectionReason", {
                    required: "rejection reason is required",
                  });
                else unregister("rejectionReason");

                setValue("subStatus", e.target.value);
                setValue("rejectionReason", "");
                if (e.target.value) {
                  const { rejectionReasons: rejectionReasonsList } = await getRejectedReasons(toast, e.target.value, row.type);
                setRejectionReasons(rejectionReasonsList);
                }
              }}
            >
              <FormLabel fontSize={12} fontWeight={"semibold"}>
                Sub Status
              </FormLabel>
              <Select value={form["subStatus"]} placeholder="Select option">
                {subStatuses?.length && (subStatuses.map((subStatus, i) => (
                  <option key={i} value={subStatus.value}
                    disabled={subStatus.value === "missing area" || subStatus.value === "missing tracking" || subStatus.value === "duplicate"}>
                    {subStatus.label}
                  </option>
                )))}
              </Select>
              <FormErrorMessage>{errors.subStatus?.message}</FormErrorMessage>
            </FormControl>

            <FormControl
              isDisabled={form["subStatus"] !== "failed attempt"}
              isRequired={form["subStatus"] === "failed attempt"}
              isInvalid={!!errors.rejectionReason}
              onChange={(e) => {
                setValue("rejectionReason", e.target.value);
              }}
            >
              <FormLabel fontSize={12} fontWeight={"semibold"}>
                Rejection Reason
              </FormLabel>
              <Select
                value={form["rejectionReason"]}
                placeholder="Select option"
              >
                {rejectionReasons?.length && (rejectionReasons.map((rejectionReason, i) => (
                  <option key={i} value={rejectionReason.value}>
                    {rejectionReason.label}
                  </option>
                )))}
              </Select>
              <FormErrorMessage>
                {errors.rejectionReason?.message}
              </FormErrorMessage>
            </FormControl>
          </ModalBody>
          <ModalFooter gap={4}>
            <Button
              colorScheme="white"
              color={"#3182ce"}
              size="sm"
              onClick={onCloseUpdateStatus}
            >
              Cancel
            </Button>
            <Button
              size="sm"
              color={"white"}
              colorScheme="blue"
              onClick={handleSubmit(handelSubmit, onError)}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
